import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgBasicClose({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path d="M2.5 1.65c.2-.2.51-.2.7 0l4.91 4.9 4.9-4.9a.5.5 0 01.65-.06l.07.06.7.7c.2.2.2.52 0 .71l-4.9 4.9 4.9 4.91c.18.17.2.44.06.64l-.06.07-.7.7a.5.5 0 01-.71 0l-4.9-4.9-4.91 4.9a.5.5 0 01-.64.06l-.07-.06-.7-.7a.5.5 0 010-.7l4.9-4.92-4.9-4.9a.5.5 0 01-.06-.64l.05-.07z" />
    </svg>
  );
}

SvgBasicClose.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgBasicClose.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgBasicClose svgRef={ref} {...props} />);
export default ForwardRef;
